const openDocument = (data, filename, mime, bom) => {
  var blobData = typeof bom !== 'undefined' ? [bom, data] : [data];
  // Important - do not use FILE - issues with Mime type for PDF
  let blob = new Blob(blobData, { type: mime || 'application/octet-stream' });
  if (typeof window.navigator.msSaveOrOpenBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
    // IPHONE and IPAD
    // IOS does not recognise the Download attribute and open the blob directly...
    var blobURL =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);

    var tempLink = document.createElement('a');
    // Opening in New Window has an issue - blocked by popup blocker... we will open in same window and see what we can do
    // tempLink.setAttribute('rel', 'noopener noreferrer');
    // tempLink.setAttribute('target', '_blank');
    tempLink.href = blobURL;
    tempLink.style.display = 'none';
    document.body.appendChild(tempLink);

    tempLink.click();

    setTimeout(function() {
      document.body.removeChild(tempLink);
    }, 200);
  } else {
    var blobURL =
      window.URL && window.URL.createObjectURL
        ? window.URL.createObjectURL(blob)
        : window.webkitURL.createObjectURL(blob);

    var tempLink = document.createElement('a');
    tempLink.style.display = 'none';
    tempLink.href = blobURL;
    // open the document new tab
    tempLink.setAttribute('download', filename);
    document.body.appendChild(tempLink);

    tempLink.click();

    // Fixes "webkit blob resource error 1"
    setTimeout(function() {
      document.body.removeChild(tempLink);
      window.URL.revokeObjectURL(blobURL);
    }, 200);
  }
};

export { openDocument };
